module.exports = __webpack_public_path__ + "img/arrow-black.034324ed.svg";